import { motion } from "framer-motion";
import { Wallet, Coins, ShoppingCart, Flame, ArrowRight } from "lucide-react";
import { SITE, STEPS } from "@/data/site";

const icons = [Wallet, Coins, ShoppingCart, Flame];

export const HowToBuy = () => {
  return (
    <section
      id="how-to-buy"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="how-to-buy-section"
    >
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-ember/10 blur-[130px] rounded-full -z-0" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-flex items-center gap-2 text-sm font-body font-bold tracking-widest uppercase text-ember mb-4">
            <ShoppingCart className="w-4 h-4" /> Join The Herd
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase text-white leading-[0.95]">
            How To <span className="fire-gradient-text">Buy</span>
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            Four steps to stampede. Under two minutes. Anyone can do it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative glass rounded-lg p-7 hover:border-gold/40 transition-colors duration-300 group"
                data-testid={`step-card-${i}`}
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="w-12 h-12 rounded-md bg-gold/10 border border-gold/30 flex items-center justify-center group-hover:bg-gold/20 transition-colors duration-300">
                    <Icon className="w-6 h-6 text-gold" />
                  </div>
                  <span className="font-display text-5xl text-white/10 leading-none">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-xl uppercase text-white">{step.title}</h3>
                <p className="mt-3 font-body text-sm text-gray-400 leading-relaxed">
                  {step.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <a
            href={SITE.links.pumpfun}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="how-to-buy-cta"
            className="inline-flex items-center gap-2 bg-gold hover:bg-gold-hover text-black font-body font-extrabold text-base px-8 py-4 rounded-md transition-transform duration-300 hover:scale-105 glow-gold uppercase tracking-wide"
          >
            Buy {SITE.ticker} Now <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
};
